import ct from "countries-and-timezones";

export const getDefaultLocaleForCountry = (isoCode) => {
  if (!isoCode) return "en-IN";
  try {
    return new Intl.Locale(`en-${isoCode.toUpperCase()}`).toString();
  } catch {
    return "en-IN";
  }
};

export const getDefaultTimezoneForCountry = (isoCode) => {
  if (!isoCode) return "Asia/Kolkata";
  const country = ct.getCountry(isoCode.toUpperCase());
  if (!country || !country.timezones.length) {
    return "Asia/Kolkata";
  }
  return country.timezones[0];
};
